export enum MEASURES {
  CM = 'cm',
  INCH = 'inch',
}

export const INCHES_TO_CM_CONVERTER = 2.54;
